import { Navigate, useParams } from 'react-router-dom'

import { paths } from './paths'

/**
 * Maps legacy workspace detail tab names and passes through canonical path segments.
 */
export const mapLegacyWorkspaceSection = (tab?: string) => {
  switch (tab) {
    case 'users':
      return 'members'
    case 'overview':
    case 'settings':
    case 'members':
    case 'roles':
    case 'security':
    case 'sso-scim':
    case 'domains':
    case 'billing':
    case 'audit':
    case 'apps':
    case 'agents':
      return tab
    default:
      return 'overview'
  }
}

const redirect = (buildTo: (id: string) => string) =>
  function WorkspacePathRedirect() {
    const { id } = useParams<{ id: string }>()
    if (!id || id === 'new') {
      return <Navigate to={paths.workspaces.root} replace />
    }
    return <Navigate to={buildTo(id)} replace />
  }

export const RedirectWorkspaceUsersToMembers = redirect((id) =>
  paths.workspaces.members(id)
)

export const RedirectWorkspaceSettingsToSecurity = redirect((id) =>
  paths.workspaces.security(id)
)

/** Legacy `/sso-scim` → Security hub SSO & SCIM tab. */
export const RedirectWorkspaceSsoScimToSecurity = () => {
  const { id } = useParams<{ id: string }>()
  if (!id || id === 'new') {
    return <Navigate to={paths.workspaces.root} replace />
  }
  return (
    <Navigate to={`${paths.workspaces.security(id)}?tab=ssoScim`} replace />
  )
}

/** Unknown or multi-segment tail under `/workspaces/:id/*` → canonical section or overview. */
export const WorkspaceTrailingPathRedirect = () => {
  const { id, '*': rest } = useParams<{ id: string; '*'?: string }>()
  if (!id || id === 'new') {
    return <Navigate to={paths.workspaces.root} replace />
  }
  if (!rest) {
    return <Navigate to={paths.workspaces.overview(id)} replace />
  }

  const first = rest.split('/').filter(Boolean)[0]

  return (
    <Navigate
      to={paths.workspaces.detailsTab(id, mapLegacyWorkspaceSection(first))}
      replace
    />
  )
}
